import "./PasswordAccount.scss";

import { useState } from "react";

import TextFieldPassword from "@elements/TextFieldPassword/TextFieldPassword";
import useUpdatePassword from "@hooks/auth/useUpdatePassword";
import { Button } from "@runwayhealth/runway-components-react";
import { ErrorEvents } from "@types-runway/state";
import { PasswordUpdate } from "@types-runway/user";
import { toastSuccess } from "@utils/utils";
import { validatePassword } from "@utils/forms/utilsFormvalidation";

interface PasswordProps {
  disablePasswordForm: boolean;
  error: string;
  setDisablePasswordForm: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PasswordAccount = ({ setDisablePasswordForm, disablePasswordForm }: PasswordProps) => {
  const [password, setPassword] = useState<PasswordUpdate>({
    oldPassword: "",
    newPassword: "",
  });
  const { updatePassword } = useUpdatePassword();
  const [errorText, setErrorText] = useState("");

  const handlerUserPassword = (event: React.SyntheticEvent, name: string) => {
    const value = ((event as React.SyntheticEvent).target as HTMLInputElement).value;
    setPassword((prev) => ({ ...prev, [name]: value }));
  };

  const save = async () => {
    if (formIsValid()) {
      const result = await updatePassword({
        oldPassword: password.oldPassword,
        newPassword: password.newPassword,
        authToken: localStorage.getItem("token") || "",
      });
      console.log(result);
      if (result.message !== "success") {
        let event = "";
        if (result?.response?.status === 404) {
          event = ErrorEvents.NOT_FOUND;
        } else if (result?.response?.status === 400) {
          event = ErrorEvents.BAD_REQUEST;
        } else if (result?.response?.status === 401) {
          event = ErrorEvents.ACCESS_DENIED;
        }
        const message = event || result?.response?.statusText || "Unknown error.";
        if (result?.response?.data?.message) {
          setErrorText(result?.response?.data?.message);
        } else {
          setErrorText(
            message === ErrorEvents.BAD_REQUEST ? result?.response?.data?.error : message
          );
        }
        return;
      }

      toastSuccess("Success!", "Your password has been updated.");
      setDisablePasswordForm(true);
    }
  };

  const formIsValid = () => {
    if (!password.oldPassword) {
      setErrorText("Please enter your current password.");
      return false;
    }

    if (!password.newPassword) {
      setErrorText("Please enter your new password.");
      return false;
    }

    if (!validatePassword(password.newPassword)) {
      setErrorText("Please enter a more secure password.");
      return false;
    }

    return true;
  };

  const isValidPassword = (password: string) => {
    if (!validatePassword(password)) {
      setErrorText("Please enter a more secure password.");
    }
  };

  return (
    <>
      <div className="account-password-change">
        <TextFieldPassword
          title="Old password"
          onChange={(e: React.SyntheticEvent) => handlerUserPassword(e, "oldPassword")}
          onBlur={(e: React.SyntheticEvent) => {}}
        />
        <TextFieldPassword
          title="New password"
          onChange={(e: React.SyntheticEvent) => handlerUserPassword(e, "newPassword")}
          onBlur={(e: React.SyntheticEvent) =>
            isValidPassword(((e as React.SyntheticEvent).target as HTMLInputElement).value)
          }
        />
      </div>
      {!disablePasswordForm && (
        <Button size="md" iconName="ArrowRight" iconPosition="right" isBlock onClick={save}>
          Change Password
        </Button>
      )}
      {errorText && (
        <div className="error-message-forgot">
          <span className="message-content-forgot">{errorText}</span>
        </div>
      )}
    </>
  );
};
